import type { ReactNode } from 'react';
import { Link } from './Link';
import type { LinkProps } from './Link.types';

type RichLinkOptions = Pick<LinkProps, 'isExternal' | 'target' | 'hasUnderline' | 'isInline' | 'className'>;

// Rich-text (`t.rich`) chunk renderer. Lives outside components (SonarQube S6478).
// links open in the same tab unless a caller opts into `target="_blank"`
export const richLink = (href: string, options?: RichLinkOptions) => (chunks: ReactNode) => (
  <Link hasUnderline href={href} {...options}>
    {chunks}
  </Link>
);
